// Estado del Modo Crisis, compartido por toda la app.
//
// Existe para que el banner y el badge del menú no consulten la API por
// separado: una sola consulta cada minuto alimenta a todos los que la necesiten.
//
// Nunca lanza ni bloquea: si la API falla, `crisis` queda en null y la
// plataforma se comporta como en un día normal.

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getCrisis } from '../services/crisisService';

const REFRESCO_MS = 60_000;

const CrisisContext = createContext({ crisis: null, cargando: true, refrescar: async () => {} });

export function CrisisProvider({ children }) {
  const [crisis, setCrisis] = useState(null);
  const [cargando, setCargando] = useState(true);

  const refrescar = useCallback(async () => {
    try {
      const d = await getCrisis();
      setCrisis(d?.activa || null);
    } catch {
      setCrisis(null);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    let vivo = true;
    const tick = async () => { if (vivo) await refrescar(); };
    tick();
    const t = setInterval(tick, REFRESCO_MS);
    return () => { vivo = false; clearInterval(t); };
  }, [refrescar]);

  return (
    <CrisisContext.Provider value={{ crisis, cargando, refrescar }}>
      {children}
    </CrisisContext.Provider>
  );
}

export function useCrisis() {
  return useContext(CrisisContext);
}

export default CrisisContext;
